import * as angular from 'angular';

import { ExistingProvider, Injectable } from "@angular/core";
import { HTTP_INTERCEPTORS, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';

import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';

@Injectable({
	providedIn: 'root'
})
export class PendingRequestsInterceptor implements HttpInterceptor {
	private _pendingRequests = 0;

	get pendingRequests(): number {
		return this._pendingRequests;
	}

	public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		// Gestion du cas particulier ou la requete ne doit pas etre comptee dans les requetes en cours
		let headers = req.headers;
		let noPendingTrace = headers.get("no-pending-trace");
		headers.delete("no-pending-trace");
		if (noPendingTrace === "true") {
			return next.handle(req);
		}

		this._pendingRequests++;
		return next.handle(req).pipe(
			finalize(
				() => this._pendingRequests--
			)
		);
	}
}

export const PendingRequestsInterceptorProvider: ExistingProvider[] = [{
	provide: HTTP_INTERCEPTORS,
	useExisting: PendingRequestsInterceptor,
	multi: true
}];